import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// Import the version‑8 Firebase database instance from your config. This
// instance should already be initialized and expose a `.ref()` method.
import { database } from "../../config/firebaseConfig";

const materialsData = []; //from '../data/materials.json';

// Local fallback plus status/error tracking
const initialState = {
  materials: materialsData.materials,
  status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

/**
 * Async thunk to load material definitions from Firebase v8.
 * Reads from the `/engineering/materials` node and returns that array.
 * If Firebase isn’t initialized or the path is missing, it returns the bundled JSON.
 */
export const fetchMaterialsAsync = createAsyncThunk(
  "materials/fetchMaterials",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      // Guard against missing database or missing .ref() in case v8 isn't set up
      if (!database || typeof database.ref !== "function") {
        return materialsData.materials;
      }
      const snapshot = await database
        .ref("engineering/materials")
        .once("value");
      // if (snapshot && snapshot.exists()) {
      //   console.log('snap', snapshot.val())
      //   dispatch(setMaterials(snapshot.val()));
      // }
      // Fall back to bundled data if node doesn’t exist
      //return materialsData.materials;
      return snapshot.exists() ? snapshot.val() : materialsData;
    } catch (error) {
      console.error("Error fetching materials:", error);
      return rejectWithValue(error.message);
    }
  }
);

const materialsSlice = createSlice({
  name: "materials",
  initialState,
  reducers: {
    // Manual override if needed
    setMaterials(state, action) {
      state.materials = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMaterialsAsync.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchMaterialsAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.materials = action.payload;
      })
      .addCase(fetchMaterialsAsync.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Failed to load materials";
      });
  },
});

// Selector to get all materials
export const selectMaterials = (state) => state.materials.materials;

// Selector to find a material by name (case-insensitive)
export const selectMaterialByName = (state, name) =>
  state.materials.materials.find(
    (m) => m.name.toLowerCase() === name.toLowerCase()
  );

export const { setMaterials } = materialsSlice.actions;

export default materialsSlice.reducer;
